export const drawer = (theme) => ({
    backgroundColor: theme.colors?.surface?.default,
    shadow: {
        left: theme.shadows?.left,
        right: theme.shadows?.right,
    },
});
//# sourceMappingURL=drawer.js.map